<template>
  <FlexColumn class="mt-12">
    <FlexRow full-width justify="center">
      <Label size="h5" text="スカウト対象求人を設定します" bold class="mb-7"/>
    </FlexRow>
    <FlexRow full-width justify="center">
      <FlexColumn width="640px" :space="4">
        <FlexColumn :space="0">
          <Label text="スカウト対象求人" bold />
          <SelectField
              v-model="jobId"
              :items="selectJobs"
              :outlined="false"
              hint="※求人が承認済みかつ公開中の求人・案件のみ選択できます"
              persistent-hint
              class="pa-0 mt-0"
          />
        </FlexColumn>
        <FlexColumn :space="0">
          <Label text="スカウト送付者" bold />
          <FlexRow>
            <SelectField
                v-model="requestorId"
                :items="requestorItems"
                :outlined="false"
                class="pa-0 mt-0"
                simple
            />
          </FlexRow>
        </FlexColumn>

        <FlexColumn :space="0">
          <Label text="スカウトメッセージテンプレート" bold />
          <FlexRow align="center">
            <SelectField
                v-model="templateId"
                :items="templateItems"
                :outlined="false"
                class="pa-0 mt-0"
                simple
            />
            <Button
              outlined
              small
              color="primary"
              @click="openMessageTemplateCreateDialog = true"
            >
              <Label text="新規" size="body-2" />
            </Button>
          </FlexRow>
        </FlexColumn>
      </FlexColumn>
    </FlexRow>
    <FlexRow full-width justify="center" class="mt-10">
      <TextButton
          :primary="jobId != null && requestorId != null"
          :disabled="jobId == null || requestorId == null"
          @click="handleSelect"
      >
        設定する
      </TextButton>
    </FlexRow>
    <ScoutMessageTemplateCreateDialog
        :open="openMessageTemplateCreateDialog"
        :companyId="company.id"
        @close="openMessageTemplateCreateDialog = false"
    />
  </FlexColumn>
</template>

<script>
import FlexColumn from "@/components/atoms/FlexColumn";
import Label from "@/components/atoms/Label";
import {mapGetters} from "vuex";
import SelectField from "@/components/atoms/SelectField";
import TextButton from "@/components/atoms/TextButton";
import FlexRow from "@/components/atoms/FlexRow";
import ApiMixin from "@/ApiMixin";
import ScoutMessageTemplateCreateDialog from "../../organisms/ScoutMessageTemplateCreateDialog";
import Button from '../../atoms/Button'
export default {
  mixins: [ApiMixin],
  name: "ChatRequestJobSettingPage",
  components: {
    Button,
    ScoutMessageTemplateCreateDialog,
    FlexRow, TextButton, SelectField, Label, FlexColumn},
  data() {
    return {
      jobId: undefined,
      requestorId: undefined,
      templateId: undefined,
      openMessageTemplateCreateDialog: false,
    }
  },
  computed: {
    ...mapGetters("user", ["user"]),
    ...mapGetters("chatRequests", ["jobs"]),
    ...mapGetters("client", ["company", "requestors"]),
    ...mapGetters("message", ["scoutTemplates"]),
    ...mapGetters("system", ["consts"]),
    selectJobs() {
      return this.jobs.map(job => ({
        value: job.id,
        label: [job.name, job.isSide ? "業務委託" : "正社員"]
      }))
    },
    requestorItems() {
      return this.requestors.map(requestor => ({
        label: `${requestor.lastName} ${requestor.firstName}`,
        value: requestor.id
      }))
    },
    templateItems() {
      return this.scoutTemplates.map(template => ({
        label: template.name,
        value: template.id,
      }))
    },
    motivations() {
      if (this.consts && this.consts.scoutMotivation) {
        return this.consts.scoutMotivation.map(item => ({
          value: item.value,
          name: item.label
        }))
      }
      return []
    },
  },
  methods: {
    handleSelect() {
      const expireTimes = 60 * 60 * 24 * 30
      this.$cookies.set('nishika.chat-requests-job', this.jobId, expireTimes)
      if (this.requestorId) {
        this.$cookies.set('nishika.chat-requests-requestor', this.requestorId, expireTimes)
      }
      this.$cookies.set('nishika.chat-requests-scout-message-template', this.templateId, expireTimes)
      this.$router.push({
        name: 'RequestsPage',
        params: {
          id: this.jobId
        },
        query: this.$route.query
      })
    },
    async getCompany() {
      const response = await this.loadCompaniesMe()
      return response.data
    },
    async getTargetJobs(companyId) {
      const response = await this.loadChatRequestTargetJobs(companyId)
      return response.data.jobs
    },
  },
  watch: {
    "user.id": {
      handler: async function(value) {
        if (value) {
          this.jobId = this.$cookies.get('nishika.chat-requests-job')
          this.requestorId = this.$cookies.get('nishika.chat-requests-requestor')
          this.templateId = this.$cookies.get('nishika.chat-requests-scout-message-template')
          const company = await this.getCompany()
          this.loadRequestors(company.id)
          const jobs = await this.getTargetJobs(company.id)
          const job = jobs.find(job => job.id === this.jobId)
          if (job && this.requestorId) {
            this.handleSelect()
          } else {
            this.$cookies.remove('nishika.chat-requests-job')
          }
        }
      },
      immediate: true
    },
    "company.id": {
      handler: function (value) {
        if (value) {
          this.loadScoutMessageTemplates(value)
        }
      },
      immediate: true
    },
  }
}
</script>

<style scoped>
>>> .v-input__slot {
  margin-bottom: 4px
}
</style>
